import './App.css';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import ProtectedRoute from './Components/ProtectedRoute';
import AppLayout from './Components/AppLayout';
import './Components/i18n'
import { LanguageProvider } from './Components/LanguageContext';
import { getAppTitle } from './Assets/enviorement';

// Lazy load all route components for better performance
const Home = lazy(() => import('./Screens/Home'));
const Detail = lazy(() => import('./Screens/Detail'));
const Cart = lazy(() => import('./Screens/Cart'));
const Checkout = lazy(() => import('./Screens/Checkout'));
const ProductManagement = lazy(() => import('./Pages/ProductManagement'));
const ProductManagementBasic = lazy(() => import('./Pages/ProductManagementBasic'));
const AdminPortal = lazy(() => import('./Pages/AdminPortal'));
const AdminLogin = lazy(() => import('./Pages/AdminLogin'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
  </div>
);





function App() {
  React.useEffect(() => {
    const setDocumentTitle = async () => {
      try {
        const title = await getAppTitle();
        document.title = title || 'Tone of Bike';
      } catch (error) {
        // console.error('Failed to set document title:', error); // Commented for production security
        document.title = 'Tone of Bike';
      }
    };
    
    setDocumentTitle();
  }, []);

  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
   <><LanguageProvider>
    <BrowserRouter>
      <AppLayout>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path='/' element={<Home/>}></Route>
            <Route path='/detail' element={<Detail/>}></Route>
            <Route path='/cart' element={<Cart/>}></Route>
            <Route path='/checkout' element={<Checkout/>}></Route>
            {/* Hide development routes in production for security */}
            {isDevelopment && (
              <>
                <Route path='/product-management' element={<ProductManagement/>}></Route>
                <Route path='/product-management-basic' element={<ProductManagementBasic/>}></Route>
              </>
            )}
            <Route path='/admin-login' element={<AdminLogin/>}></Route>
            <Route path='/39485726109384756012938475620938475610293847561029/*' element={
              <ProtectedRoute>
                <AdminPortal/>
              </ProtectedRoute>
            }></Route>
          </Routes>
        </Suspense>
      </AppLayout>
    </BrowserRouter>
    </LanguageProvider>
   </>
  );
}

export default App;